import { useState, useEffect } from 'react';
import { outletApi } from 'src/api/outletApi';
import toast from 'react-hot-toast';

/**
 * Custom hook to fetch and manage blacklisted outlets
 * @returns {Object} Object containing blacklisted outlets array, loading state, and error
 */
const useBlacklistedOutlets = () => {
  const [blacklistedOutlets, setBlacklistedOutlets] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchOutlets = async () => {
      try {
        setIsLoading(true);
        const outlets = await outletApi.fetchOutlets();
        // Filter to only include blacklisted outlets
        const blacklisted = outlets?.filter((outlet) => outlet?.type === 'blacklisted' && outlet?.valid === 1);
        setBlacklistedOutlets(blacklisted?.map((o) => o?.outlet?.toLowerCase()));
      } catch (err) {
        setError(err);
        toast.error('Error fetching blacklisted outlets');
      } finally {
        setIsLoading(false);
      }
    };

    fetchOutlets();
  }, []);

  return { blacklistedOutlets, isLoading, error };
};

export default useBlacklistedOutlets;
